import styles from "./ArrayCardFragment.module.css";
import { CardFragmentCommonProps } from "@coworker/apprestructured/src/task-management/components/TaskCard/card-fragments/CardFragment";
import { getByPath } from "@coworker/apprestructured/src/shared/helpers/object.helper";
import { isLoading } from "@coworker/apprestructured/src/task-management/loading";
import LoadingCardFragment from "@coworker/apprestructured/src/task-management/components/TaskCard/card-fragments/LoadingCardFragment/LoadingCardFragment";
import { getTypedValue } from "@coworker/apprestructured/src/shared/helpers/schemaValidator";
import { type FieldFormat } from "@coworker/apprestructured/src/task-management/hooks/useFormatFieldValue";
import { FixaText } from "@coworker/apprestructured/src/shared/wrappers/FixaText/FixaText";
import { useFormatArrayFieldValue } from "@coworker/apprestructured/src/task-management/hooks/useFormatArrayFieldValue";

export type ArrayCardFragmentConfigProps = {
  field: string;
  format?: FieldFormat;
};

type ArrayCardFragmentProps = {
  configProps: ArrayCardFragmentConfigProps;
  commonProps: CardFragmentCommonProps;
};

function ArrayCardFragment({
  configProps,
  commonProps,
}: ArrayCardFragmentProps) {
  const { field, format } = configProps;
  const { task } = commonProps;
  const formatFieldValue = useFormatArrayFieldValue();

  if (!field) {
    return null;
  }

  const rawAreas = getTypedValue<unknown[]>(getByPath(task, field));

  if (isLoading(rawAreas)) {
    return <LoadingCardFragment />;
  } else if (!rawAreas) {
    return null;
  }

  // Auto-detect format: if all elements are strings, use directly; otherwise extract "value" from objects
  const isStringArray = rawAreas.every((item) => typeof item === "string");
  const stringAreas: string[] = isStringArray
    ? (rawAreas as string[])
    : rawAreas.map((item) =>
        typeof item === "object" && item !== null
          ? String((item as Record<string, unknown>)["value"] ?? "")
          : String(item)
      );

  const text = formatFieldValue(stringAreas, format);

  return <FixaText className={styles["root"]}>{text}</FixaText>;
}

export default ArrayCardFragment;
